import { MarkExtension, MarkGroup, toggleMark, markInputRule, markPasteRule, extensionDecorator } from '@remirror/core';

var _dec, _class;
/**
 * The extension for adding strike-through marks to the editor.
 */

var StrikeExtension = (_dec = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec(_class = class StrikeExtension extends MarkExtension {
  get name() {
    return 'strike';
  }

  createMarkSpec(extra) {
    return {
      attrs: extra.defaults(),
      group: MarkGroup.FontStyle,
      parseDOM: [{
        tag: 's',
        getAttrs: extra.parse
      }, {
        tag: 'del',
        getAttrs: extra.parse
      }, {
        tag: 'strike',
        getAttrs: extra.parse
      }, {
        style: 'text-decoration',
        getAttrs: node => node === 'line-through' ? {} : false
      }],
      toDOM: mark => ['s', extra.dom(mark), 0]
    };
  }

  createKeymap() {
    return {
      'Mod-d': toggleMark({
        type: this.type
      })
    };
  }

  createCommands() {
    return {
      /**
       * Toggle the strike through formatting annotation.
       */
      toggleStrike: () => toggleMark({
        type: this.type
      })
    };
  }

  createInputRules() {
    return [markInputRule({
      regexp: /~([^~]+)~$/,
      type: this.type
    })];
  }

  createPasteRules() {
    return [markPasteRule({
      regexp: /~([^~]+)~/g,
      type: this.type
    })];
  }

}) || _class);

export { StrikeExtension };
